/**
 * ResponsavelConfigWhatsapp
 * @author gabrielbgil
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigWhatsappSchema from '@/schema/ResponsavelConfigWhatsapp.schema'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import WhatsappStatus from '@/model/resource/WhatsappStatus'

export default class ResponsavelConfigWhatsapp extends Resource {
  readonly $name: string = 'ResponsavelConfigWhatsapp'

  readonly $endpoint: string = '/user/config-whatsapp/configuracao{/id}'

  get $schema() {
    return ResponsavelConfigWhatsappSchema(this)
  }

  get $id() {
    return this.idConfigWhatsappPk
  }
  set $id(val: ID) {
    this.idConfigWhatsappPk = val
  }

  get isOcorrenciaSelected() {
    return this.status && this.status.idStatusPk === StatusSms.OCORRENCIA
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(StatusSms)
  status: StatusSms | null = null

  @ResponseSerialize(WhatsappStatus)
  whatsappApprovalStatus: WhatsappStatus | null = null

  @ResponseSerialize(TipoOcorrencia)
  ocorrencia: TipoOcorrencia | null = null

  idConfigWhatsappPk: ID = 0

  templateId: string | null = null

  @ValidationRequired()
  @ValidationMaxLength(2000)
  mensagem: string = ''

  @ValidationRequired()
  ativo: boolean = true

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  get idWhatsappApprovalStatusFk() {
    if (!this.whatsappApprovalStatus) return 0
    return this.whatsappApprovalStatus.$id
  }
  set idWhatsappApprovalStatusFk(idWhatsappApprovalStatusFk: ID) {
    if (!this.whatsappApprovalStatus) this.whatsappApprovalStatus = new WhatsappStatus()
    this.whatsappApprovalStatus.$id = idWhatsappApprovalStatusFk
  }

  idStatusFk: ID = 0

  async persistResponsavelConfigWhatsapp(
    model?: ResponsavelConfigWhatsapp,
    spinner = 'persistResponsavelConfigWhatsapp',
  ) {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/config-whatsapp/configuracao`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getResponsavelConfigWhatsapp(id: number, spinner = 'getResponsavelConfigWhatsapp') {
    const fetch = async () => await this.GET(`/user/config-whatsapp/configuracao/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
